import { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import styles from "./TeacherForm.module.css";



const TeacherForm = ({ schoolList, authStart }) => {
  
  const [openList, setopenList] = useState(false);
  const [schoolName, setSchoolName] = useState(localStorage.getItem('name') ? localStorage.getItem('name') : "");
  const [schoolTitle, setSchoolTitle] = useState(localStorage.getItem('title') ? localStorage.getItem('title') : "");
  const [filteredList, setFilteredList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(0);
  const [search, setSearch] = useState("");
  const [editing, setEditing] = useState(false);
  const selectRef = useRef(null);
  const inputRef = useRef(null);
  const clearingRef = useRef(false);

  const formik = useFormik({
    initialValues: {
      password: "",
      schooltype: "lms",
      username: "",
      school: "",
    },
    onSubmit: (values) => {
      authStart({ ...values, school: schoolName });
      setSchoolTitle("");
      localStorage.setItem('name', schoolName)
      localStorage.setItem('title', schoolTitle)
    },
  });

  const selectSchool = (item) => {
    setopenList(false);
    setEditing(false);
    setSchoolTitle(item.Title);
    setSchoolName(item.Name);
    setSearch("");
  }

  const inputSchoolName = (e) => {
    setopenList(true);
    setSelectedItem(0)
    setSearch(e.target.value)
  }

  const openSchoolSearch = () => {
    if (clearingRef.current) {
      return;
    }

    setEditing(true);
    setSearch(schoolTitle);
    setSelectedItem(0);
    setopenList(true);
  }

  const closeSchoolSearch = () => {
    setEditing(false);
  }

  const handleInputClick = () => {
    if (!openList) {
      openSchoolSearch();
    }
  }

  const clearSearch = () => {
    clearingRef.current = true;

    setSearch("");
    setSelectedItem(0);
    setEditing(true);
    setopenList(true);

    if (inputRef.current) {
      inputRef.current.focus();
    }

    clearingRef.current = false;
  }

  useEffect(() => {
    const handler = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setEditing(false);
        setopenList(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  useEffect(() => {
    const query = search.toLowerCase().trim();

    if (!query) {
      setFilteredList(schoolList);
    } else {
      setFilteredList(
        schoolList.filter((item) =>
          item.Title.toLowerCase().includes(query)
        )
      );
    }
  }, [search, schoolList]);

  useEffect(() => {
    const handler = (event) => {
      if (!openList) return;

      if (event.keyCode === 40) {
        event.preventDefault();
        selectedItem >= filteredList.length-1 ? setSelectedItem(filteredList.length-1) : setSelectedItem(selectedItem + 1);
      } else if (event.keyCode === 38) {
        event.preventDefault();
        selectedItem <= 0 ? setSelectedItem(0) : setSelectedItem(selectedItem - 1); 
      } else if (event.keyCode === 13) {
        event.preventDefault();
        if (filteredList[selectedItem]) {
          setopenList(false);
          setEditing(false);
          setSchoolTitle(filteredList[selectedItem].Title);
          setSchoolName(filteredList[selectedItem].Name);
          setSearch("");
          if (document.activeElement) {
            document.activeElement.blur();
          }
        }
      } else if (event.keyCode === 27) {
        setopenList(false);
      }
    };

    document.addEventListener("keydown", handler);

    return () => {
      document.removeEventListener("keydown", handler);
    };
  }, [selectedItem, filteredList, openList]);

  return (
    <form className={styles.login_form} autoComplete="on" onSubmit={formik.handleSubmit}>
      <div className={styles.title}>Выбрать учебное заведение:</div>
      <div className={styles.select} ref={selectRef}>
        <div className={styles.inputWrapper}>
          <input
            ref={inputRef}
            className={styles.selected}
            placeholder="Учебное заведение не выбрано"
            onChange={(e) => inputSchoolName(e)}
            onFocus={openSchoolSearch}
            onClick={handleInputClick}
            onBlur={closeSchoolSearch}
            value={editing ? search : schoolTitle}
            readOnly={!editing}
            autoComplete="school"
          />
          {(editing ? search : schoolTitle) && (
            <button
              type="button"
              className={styles.clearButton}
              onMouseDown={(e) => e.preventDefault()}
              onClick={clearSearch}
              aria-label="Очистить поиск"
            >
              ×
            </button>
          )}
        </div>
        {openList && (
          <div className={styles.list}>
            {filteredList.map((item, i) => (
              <div
                className={
                  i === selectedItem
                    ? styles.listElement + " " + styles.choice
                    : styles.listElement
                }
                key={item.Name}
                onClick={() => selectSchool(item)}
                onMouseEnter={() => setSelectedItem(i)}
              >
                {item.Title}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={styles.login_title2}>Введите логин/пароль:</div>
      <input
        className={styles.login_input}
        name="username"
        value={formik.values.username}
        onChange={formik.handleChange}
        placeholder="Логин"
      />
      <input
        className={styles.pass_input}
        name="password"
        value={formik.values.password}
        onChange={formik.handleChange}
        type="password"
        placeholder="Пароль"
      />
      <button className={styles.input_btn}>Войти</button>
    </form>
  );
};

export default TeacherForm;